import { useNavigate } from "react-router-dom";
import { HStack, IconButton, Spinner, Table, Text, VStack } from "@chakra-ui/react";
import { HiArrowRight, HiOutlineInformationCircle } from "react-icons/hi2";
import { DetailTableShell, tableHeaderStyle, WorkflowStatusBadge } from "@/components/ui/detail/primitives";

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("pl-PL") : "—");

const COLUMNS = ["Nazwa", "Status", "Scenariusz", "Utworzono", "Akcje"];

const ClientCampaignsTab = ({ clientId, campaigns, isLoading }) => {
    const navigate = useNavigate();

    return (
        <VStack w="full" align="flex-start" gap={3} pt={4}>
            <HStack color="text.grey" fontSize="xs" gap={1.5}>
                <HiOutlineInformationCircle />
                <Text>Kampanie zakłada i edytuje się w panelu klienta. Tutaj są dostępne tylko do podglądu.</Text>
            </HStack>

            {isLoading ? (
                <VStack w="full" py={8} align="center"><Spinner color="white" size="md" /></VStack>
            ) : (
                <DetailTableShell>
                    <Table.Root>
                        <Table.Header>
                            <Table.Row bg="bg.card" borderBottom="1px solid" borderColor="border.primary">
                                {COLUMNS.map((col, i) => (
                                    <Table.ColumnHeader key={col} {...tableHeaderStyle} textAlign={i === COLUMNS.length - 1 ? "right" : "left"}>
                                        {col}
                                    </Table.ColumnHeader>
                                ))}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {campaigns.length === 0 ? (
                                <Table.Row bg="bg.secondary">
                                    <Table.Cell colSpan={COLUMNS.length} py={8} border="none" textAlign="center">
                                        <Text color="text.grey" fontSize="sm">Brak kampanii</Text>
                                    </Table.Cell>
                                </Table.Row>
                            ) : campaigns.map((c) => (
                                <Table.Row key={c.id} bg="bg.secondary" borderBottom="1px solid" borderColor="border.primary" _hover={{ bg: "bg.highlight" }} transition="background 0.15s">
                                    <Table.Cell py={4} px={5} border="none">
                                        <Text color="white" fontSize="sm" fontWeight={500}>{c.name}</Text>
                                    </Table.Cell>
                                    <Table.Cell py={4} px={5} border="none">
                                        <WorkflowStatusBadge status={c.status} />
                                    </Table.Cell>
                                    <Table.Cell py={4} px={5} border="none">
                                        <Text color="text.grey" fontSize="sm">{c.scenario?.name ?? "—"}</Text>
                                    </Table.Cell>
                                    <Table.Cell py={4} px={5} border="none">
                                        <Text color="text.grey" fontSize="sm">{fmtDate(c.createdAtUtc)}</Text>
                                    </Table.Cell>
                                    <Table.Cell py={4} px={5} border="none" textAlign="right">
                                        <IconButton variant="outlined" size="sm" aria-label="Szczegóły kampanii" onClick={() => navigate(`/clients/${clientId}/campaigns/${c.id}`)}>
                                            <HiArrowRight />
                                        </IconButton>
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table.Root>
                </DetailTableShell>
            )}
        </VStack>
    );
};

export default ClientCampaignsTab;
